export default __webpack_public_path__ + "static/media/LF-2Closed.fd029742.jpg";